module.exports = __webpack_public_path__ + "img/pause.1bf23297.png";